<script>
    import OverallProgressBar from "./OverallProgressBar.svelte";
</script>

<div class="flex flex-col mx-6">
    <div class="w-auto mb-2 overflow-hidden">
        <OverallProgressBar/>
    </div>
    <div class="flex gap-10 justify-between mb-3">
        <slot name="left-button"></slot>
        <slot name="right-button" class="ml-auto"></slot>
    </div>
</div>
